module.exports = __webpack_public_path__ + "static/media/church-domes.ed665afd.png";